import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

/**
 * Shows the queries behind one table or chart so a SUPER user can run them by hand.
 * sql: [{label, sql, ms?}]
 */
export default function StatsSqlDialog({ open, onClose, title, sql, t }) {
  const [copied, setCopied] = useState(null);
  const tr = (k, fallback) => (t ? t(k) : null) || fallback;

  const copy = (text, idx) => {
    try {
      navigator.clipboard.writeText(text).then(() => {
        setCopied(idx);
        setTimeout(() => setCopied(null), 1500);
      });
    } catch (e) {
      // clipboard not available; the text stays selectable
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle style={{ fontSize: 16 }}>{title}</DialogTitle>
      <DialogContent dividers>
        {(sql || []).length === 0 && <p style={{ opacity: 0.7 }}>–</p>}
        {(sql || []).map((q, idx) => (
          <div key={idx} style={{ marginBottom: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, marginBottom: 4 }}>
              <span style={{ fontSize: 13, fontWeight: 600 }}>
                {q.label}{typeof q.ms !== 'undefined' ? <span style={{ fontWeight: 400, opacity: 0.6, marginLeft: 8 }}>{q.ms} ms</span> : null}
              </span>
              <Button size="small" variant="outlined" onClick={() => copy(q.sql, idx)}>
                {copied === idx ? tr('stats_copied', 'Gekopieerd') : tr('stats_copy', 'Kopiëren')}
              </Button>
            </div>
            <pre style={{ margin: 0, padding: '8px 10px', fontSize: 12, lineHeight: 1.45, whiteSpace: 'pre-wrap', wordBreak: 'break-word', background: 'rgba(128,128,128,0.10)', borderRadius: 4, maxHeight: 320, overflow: 'auto' }}>{q.sql}</pre>
          </div>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{tr('stats_close', 'Sluiten')}</Button>
      </DialogActions>
    </Dialog>
  );
}
